import React, { useContext, useEffect } from "react";
import { AuthContext } from "../auth";
import translation from "../translations.json";
import { translateByKey } from "../utils";

export function Footer() {
  const authContext = useContext(AuthContext);
  useEffect(() => {

  }, [])
  //console.log(translation.footer_menus, translation.footer_sub_menus)
  return (
    <>
      <div id="trueid-login-widget"
              data-lang="en"
              data-type="dark-bar-button"
              data-auto="N"
              data-style="modal"
              data-button="custom"
      >
      </div>
      <footer>
        <div className="footer-BG">
          <div className="pr-4">
            <p>{translateByKey(translation['support_text_1'], authContext?.lang)}</p>
            <p className="mr-4">{translateByKey(translation['support_text_2'], authContext?.lang)}</p>
          </div>
          <div className="pl-4">
            <h5 className="m-0">
            <a className="no-link" href={`tel://${translateByKey(translation['contact_number'], authContext?.lang)}`}>
            {translateByKey(translation['contact_number'], authContext?.lang)}
              <img className="ml-4" src="/ondemand/static/img/tel.png" alt="" />
            </a>
            </h5>
          
          </div>
        </div>
        <div className="social-BG container mt-4 mb-4">
          <div>
            <img src="/ondemand/static/img/f-info.png" alt="" className="mr-1" />
            คำถามและข้อสงสัย
          </div>
          <div>
            <img src="/ondemand/static/img/f-call.png" alt="" className="mr-1" />
            คอลเซ็นเตอร์
          </div>
          <div>
            <img src="/ondemand/static/img/f-msg.png" alt="" className="mr-1" />
            สอบถามออนไลน์
          </div>
          <div>
            <img src="/ondemand/static/img/f-location.png" alt="" className="mr-1" />
            สาขาและศูนย์บริการ
          </div>
          <div>
            <img src="/ondemand/static/img/f-doc.png" alt="" className="mr-1" />
            แบบสอบถาม
          </div>
          <div>
            <img src="/ondemand/static/img/f-msg.png" alt="" className="mr-1" />
            บริการถาม-ตอบด้วยภาษามือ
          </div>
          <div>
            <a href="https://www.facebook.com/Truevisions">
              <img src="/ondemand/static/img/f-fb.png" alt="" className="mr-3" />
            </a>
            <a href="https://twitter.com/TrueVisions">
              <img src="/ondemand/static/img/f-tw.png" alt="" className="mr-3" />
            </a>
            <a href="https://www.instagram.com/truevisionsofficial/">
              <img src="/ondemand/static/img/f-ig.png" alt="" className="mr-3" />
            </a>
            <a href="https://www.youtube.com/user/TrueVisionsOfficial">
              <img src="/ondemand/static/img/f-yt.png" alt="" className="mr-3" />
            </a>
          </div>
        </div>
        <div className="link-BG">
          <div className="detail container mt-4 mb-4 pt-4">
            {translation['footer_sub_menus'].map((menus:any[]) => {
              return <FooterMenuGroup menuList={menus} lang={authContext?.lang ? authContext.lang: 'th'} />
              
            
            })}
          </div>
          <div className="pb-4">
            <hr />
            <p className="text-center m-0">
              © True Corporation Public Company Limited All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}

type MenuGroupProps = {
  menuList: any[];
  lang: String;
}

function FooterMenuGroup(props: MenuGroupProps) {
  const {menuList, lang} = props

  
  return (
    <>
    {menuList.map((menu) => {
      let useMenu = menu.th
      if (lang === 'en') {
        useMenu = menu.en
      }
      return (
        <div>
          <p>{useMenu.title}</p>
          <ul>
            {useMenu.subMenus && useMenu.subMenus.map((sub:any) => {
              return (
                <li>
                  <a href={sub.link}>{sub.title}</a>
                </li>
              )
            })}
          </ul>
        </div>
      )})}
    </>
  )
}